module.exports = __webpack_public_path__ + "img/DE01917.ccef0624.png";